import {
    CopyOutlined,
    LinkOutlined,
    DeleteOutlined,
    CheckOutlined,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    Col,
    Form,
    Input,
    List,
    Row,
    Typography,
    message,
    Tooltip,
    Popconfirm,
    Collapse,
} from "antd";
import { useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const DomainManagement = ({ appName, app, getData }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const ref = useRef();
    const { t } = useTranslation();
    const linkDomain = async (values, appTechnology) => {
        const body = {
            appBudleName: appName,
            appTechnology,
            domain: values.domain,
        };

        setLoading(true);

        try {
            await HTTPClient.post("/app/link_domain", body);
            message.success(t("dettaglio_app.domain_management.success"));
            getData(app.technology);
        } catch (e) {
            message.error(t("dettaglio_app.domain_management.error"));
        }
        setLoading(false);
    };

    const unlinkDomain = async (domain) => {
        const body = {
            appBudleName: appName,
            domain,
        };
        try {
            await HTTPClient.patch("/app/unlink_domain", body);
            message.success(t("dettaglio_app.domain_management.unlink.success"));
            getData(app.technology);
        } catch (e) {
            message.error(t("dettaglio_app.domain_management.unlink.error"));
        }
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    if (!app?.url_custom) return null;
    return (
        <Card title="Gestione domini" style={{ width: "100%", marginTop: "10px" }}>
            <Collapse
                items={[
                    {
                        key: "1",
                        label: (
                            <Row
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}>
                                <Typography.Text>
                                    {t("dettaglio_app.domain_management.how_to")}
                                </Typography.Text>
                                <QuestionCircleOutlined />
                            </Row>
                        ),

                        children: (
                            <Typography.Text>
                                {t("dettaglio_app.domain_management.info.1")}
                                <br />
                                {t("dettaglio_app.domain_management.info.2")}
                                <br />
                                {t("dettaglio_app.domain_management.info.3")}
                                <br />
                                <p
                                    style={{ cursor: "pointer", fontWeight: "bold" }}
                                    onClick={() => {
                                        navigator.clipboard.writeText("49.12.113.131");
                                        message.success(
                                            t("dettaglio_app.domain_management.copied")
                                        );
                                    }}>
                                    {" "}
                                    <CopyOutlined /> 49.12.113.131
                                </p>
                                <br />
                                {t("dettaglio_app.domain_management.info.4")}
                                <p
                                    style={{ cursor: "pointer", fontWeight: "bold" }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(app?.k8s_ingress?.url);
                                        message.success(
                                            t("dettaglio_app.domain_management.copied")
                                        );
                                    }}>
                                    {" "}
                                    <CopyOutlined /> {app?.k8s_ingress?.url}
                                </p>
                                <br />
                                {t("dettaglio_app.domain_management.info.5")}
                                <br />
                                {t("dettaglio_app.domain_management.info.6")}
                            </Typography.Text>
                        ),
                    },
                ]}
            />
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Col xs={24} sm={24} md={24} lg={12}>
                    <Typography.Text>
                        <Form
                            name="basic"
                            ref={ref}
                            form={form}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            onFinish={async (values) => {
                                await linkDomain(values, app?.technology);
                            }}
                            validateTrigger="onSubmit"
                            autoComplete="off">
                            <Form.Item
                                name="domain"
                                rules={[
                                    {
                                        required: true,
                                        message: t(
                                            "dettaglio_app.domain_management.fields.domain.message"
                                        ),
                                    },
                                ]}>
                                <Input
                                    placeholder={t(
                                        "dettaglio_app.domain_management.fields.domain.placeholder"
                                    )}
                                />
                            </Form.Item>

                            <Form.Item
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    loading={loading}>
                                    {t("dettaglio_app.domain_management.confirm")}
                                </Button>
                            </Form.Item>
                        </Form>
                        {!app?.domains || !app.domains?.length ? null : (
                            <List
                                style={{ width: "100%" }}
                                header={<div> {t("dettaglio_app.domain_management.title")}</div>}
                                dataSource={app.domains}
                                renderItem={(item, index) => (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={<LinkOutlined />}
                                            title={
                                                <Row
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        flexDirection: isLargeScreen
                                                            ? "row"
                                                            : "column",
                                                        justifyContent: "space-between",
                                                    }}>
                                                    <div>
                                                        <a
                                                            style={{
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                            }}
                                                            href={"https://" + item.domain}
                                                            target="_blank"
                                                            rel="noreferrer">
                                                            {item.domain}
                                                        </a>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            gap: "10px",
                                                        }}>
                                                        <Tooltip
                                                            placement="top"
                                                            title={"Dominio verificato"}>
                                                            <CheckOutlined
                                                                style={{
                                                                    color: "green",
                                                                    fontSize: "large",
                                                                }}
                                                            />
                                                        </Tooltip>
                                                        <Popconfirm
                                                            title={t(
                                                                "dettaglio_app.domain_management.unlink.pop_confirm.title"
                                                            )}
                                                            description={() =>
                                                                t(
                                                                    "dettaglio_app.domain_management.unlink.pop_confirm.subtitle"
                                                                )
                                                            }
                                                            onConfirm={() =>
                                                                unlinkDomain(item.domain)
                                                            }
                                                            onCancel={() => {}}
                                                            okButtonProps={{ size: "large" }}
                                                            cancelButtonProps={{
                                                                size: "large",
                                                            }}
                                                            okText={t(
                                                                "dettaglio_app.domain_management.unlink.pop_confirm.ok"
                                                            )}
                                                            cancelText={t(
                                                                "dettaglio_app.domain_management.unlink.pop_confirm.ko"
                                                            )}
                                                            style={{ alignSelf: "right" }}>
                                                            <Button
                                                                type="primary"
                                                                danger
                                                                icon={<DeleteOutlined />}></Button>
                                                        </Popconfirm>
                                                    </div>
                                                </Row>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                        )}
                    </Typography.Text>
                </Col>
            </Row>
        </Card>
    );
};

export { DomainManagement };
